import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    .modal-container {
        background-color: #e2c8b7;

        .modal-body {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 !important;
        }
    }
    
    .col {
        &.col-left {
            width: 30%;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            gap: 1em;
            color: #734525;
            padding: 3em;

            
            .col-header {
                text-transform: uppercase;

                .headline {
                    font-size: 3em;
                    font-weight: 700;
                    padding-top: 1em;
                }
                .subheadline {}
            }

            .col-content {
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;
                gap: 1em;

                .layout-forms-input {
                    .layout-forms-input-wrapper {
                        .label-wrapper {
                            .label-body {
                                .layout-forms-input-label {
                                    transform: translateY(0);
                                    opacity: 1;
                                    color: #734525;
                                }
                            }
                        }
                    }
                }

                .cta {
                    .button {
                        height: 3.5em;
                    }
                }
                .legend {}
            }
        }

        &.col-right {
            width: 70%;

            .element-image {
                padding: 77% 0 0 0;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
            }
        }
    }

    @media all and (max-width: ${variables.tabletL}) {
        .col {
            &.col-left { 
                width: 100%;

                .col-header {
                    .headline {
                        br {
                            display: none;
                        }
                    }
                }

                .col-content {
                    width: 100%;
                }
            }

            &.col-right {
                display: none;
            }
        }
    }
`;
